import { createAction } from 'redux-actions';

import {
  FETCH_EVENTS_REQUEST,
  APPEND_EVENT_SUCCESS,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  PUSH_GLOBAL_EVENT,
  DISPLAY_GLOBAL_EVENT,
  SET_CURRENT_EVENT,
  UNSET_CURRENT_EVENT,
  MUTE_EVENTS
} from './constants';

const fetchEvents = createAction(
  FETCH_EVENTS_REQUEST,
  (token: string) => ({ token }),
);

const appendEvent = createAction(
  APPEND_EVENT_SUCCESS,
  (event: any) => event,
);

const setEvents = createAction(
  FETCH_EVENTS_SUCCESS,
  (events: any[]) => events,
);

const pushGlobalEvent = createAction(
  PUSH_GLOBAL_EVENT,
  (event: any, token: string) => ({ event, token })
);

const displayGlobalEvent = createAction(
  DISPLAY_GLOBAL_EVENT,
  (event: any) => event,
);

const setCurrentEvent = createAction(
  SET_CURRENT_EVENT,
  (event: any) => event,
);

const unsetCurrentEvent = createAction(
  UNSET_CURRENT_EVENT
);

const setEventsError = createAction(
  FETCH_EVENTS_FAILURE,
  (error: string) => error,
);

const muteEvents = createAction(
  MUTE_EVENTS,
  (muted: boolean) => muted,
);

export {
  fetchEvents,
  appendEvent,
  setEvents,
  setEventsError,
  pushGlobalEvent,
  displayGlobalEvent,
  setCurrentEvent,
  unsetCurrentEvent,
  muteEvents,
};
